import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Search from './Search';
import Header from './Header';
import { fetchAllAdvertisement } from '../../service/AdService';
import UserFooter from './UserFooter';
import { fetchAllVisitingTime } from '../../service/VisitingTime';
import { apiUrl } from '../../config';
import '../../styles/App.css'

const Results = () => {
    const location = useLocation();
    const [ads, setAds] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const { specialist, selectingId, selectedType } = location.state || {};
    const [showVisitModal, setShowVisitModal] = useState(false);
    const [selectedDetails, setSelectedDetails] = useState([]);

    useEffect(() => {
        loadAds();
    }, [specialist]);

    const loadAds = async () => {
        try {
            const ads = await fetchAllAdvertisement();
            const allVisitingTimes = await fetchAllVisitingTime();

            const adsWithVisitingTimes = ads.map((ad) => ({
                ...ad,
                visitingTimes: allVisitingTimes.filter((v) => v.adId === ad.id),
            }));

            setAds(adsWithVisitingTimes);

            const response = adsWithVisitingTimes.filter(
                (item) =>
                    item.category?.toLowerCase() === specialist?.toLowerCase()
            );

            setFiltered(response);
        } catch (err) {
            console.error("Failed to fetch advertisement", err);
        }
    };

    const openVisitModal = (visit) => {
        setSelectedDetails(visit);
        setShowVisitModal(true);
    };

    return (
        <>
            <Header />

            <div className="row">
                <div className="col-12 marquee-row">
                    <marquee className="marquee-announcement">
                        <span className="fw-bold">
                            📢 Hospital Advertisement: Please Contact -
                            <a
                                href="#"
                                className="text-white ms-2"
                                style={{ textDecoration: "none" }}
                            >
                                04362 - 238 235
                            </a>
                            🎉
                        </span>
                    </marquee>
                </div>
            </div>

            <div className="mb-4">
                <Search
                    initialSpecialist={specialist}
                    initialType={selectedType}
                />
            </div>

            {/* <div className="container mb-5">
                <div className="row">

                    {filtered.length > 0 ? (
                        filtered.map((item, idx) => (
                            <div
                                key={idx}
                               className="col-12 mb-4 d-flex"
                            >
                                <div className="result-card w-100 p-3 shadow-sm rounded">

                                    <div className="d-flex flex-column flex-sm-row gap-3">

                                        <img
                                            src={
                                                item.imageUrl
                                                    ? apiUrl + "/" + item.imageUrl
                                                    : "/images/hospital.jpg"
                                            }
                                            alt={item.title}
                                            className="img-fluid"
                                            style={{
                                                width: "120px",
                                                height: "120px",
                                                borderRadius: "10px",
                                                objectFit: "cover",
                                            }}
                                        />

                                        <div className="flex-grow-1">
                                            <h5 className="fw-bold">{item.title}</h5>

                                            <div
                                                className="small text-muted mb-1"
                                                dangerouslySetInnerHTML={{
                                                    __html: item.description,
                                                }}
                                            />

                                            {[item.address1, item.address2, item.address3, item.address4]
                                                .filter(Boolean)
                                                .map((line, i) => (
                                                    <div className="small" key={i}>
                                                        {line}
                                                    </div>
                                                ))}

                                            {[item.phoneNo1, item.phoneNo2, item.phoneNo3]
                                                .filter(Boolean)
                                                .map((phone, i) => (
                                                    <div className="small fw-bold" key={i}>
                                                        {phone}
                                                    </div>
                                                ))}
                                            <div className="d-flex flex-wrap gap-2 mt-2">
                                                {item.visitingTimes?.length > 0 && (
                                                    <button
                                                        className="btn btn-secondary btn-sm"
                                                        onClick={() =>
                                                            openVisitModal(item.visitingTimes)
                                                        }
                                                    >
                                                        Visiting Details
                                                    </button>
                                                )}

                                                {item.webUrl && (
                                                    <a
                                                        href={item.webUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-info btn-sm text-white"
                                                    >
                                                        More Details
                                                    </a>
                                                )}

                                                {item.type && (
                                                    <a
                                                        href={`/userAttachment?url=${encodeURIComponent(
                                                            item.type
                                                        )}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-info btn-sm text-white"
                                                    >
                                                        More Details
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="col-12">
                            <div className="result-card p-3 text-center fw-bold text-dark">
                                No matching advertisements found.
                            </div>
                        </div>
                    )}

                </div>
            </div> */}

            <div className="container mb-5">
                <div className="row">

                    {filtered.length > 0 ? (
                        filtered.map((item, idx) => (
                            <div
                                key={idx}
                                className="col-12 d-flex"
                                style={{ marginBottom: "60px" }}
                            >
                                <div className="result-card w-100 p-3 shadow-sm rounded">

                                    <div className="d-flex flex-column flex-sm-row gap-3">

                                        <img
                                            src={
                                                item.imageUrl
                                                    ? apiUrl + "/" + item.imageUrl
                                                    : "/images/hospital.jpg"
                                            }
                                            alt={item.title}
                                            className="img-fluid"
                                            style={{
                                                width: "120px",
                                                height: "120px",
                                                borderRadius: "10px",
                                                objectFit: "cover",
                                            }}
                                        />

                                        <div className="flex-grow-1">
                                            <h5 className="fs-4">{item.title}</h5>

                                            <div
                                                className="fs-5 mb-1"
                                                dangerouslySetInnerHTML={{
                                                    __html: item.description,
                                                }}
                                            />

                                            {[item.address1, item.address2, item.address3, item.address4]
                                                .filter(Boolean)
                                                .map((line, i) => (
                                                    <div className="fs-5" key={i}>
                                                        {line}
                                                    </div>
                                                ))}

                                            {[item.phoneNo1, item.phoneNo2, item.phoneNo3]
                                                .filter(Boolean)
                                                .map((phone, i) => (
                                                    <div className="fs-5" key={i}>
                                                        {phone}
                                                    </div>
                                                ))}

                                            <div className="d-flex flex-wrap gap-2 mt-2">
                                                {item.visitingTimes?.length > 0 && (
                                                    <button
                                                        className="btn btn-secondary btn-sm"
                                                        onClick={() =>
                                                            openVisitModal(item.visitingTimes)
                                                        }
                                                    >
                                                        Visiting Details
                                                    </button>
                                                )}

                                                {item.webUrl && (
                                                    <a
                                                        href={item.webUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-info btn-sm text-white"
                                                    >
                                                        More Details
                                                    </a>
                                                )}

                                                {item.type && (
                                                    <a
                                                        href={`/userAttachment?url=${encodeURIComponent(
                                                            item.type
                                                        )}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-info btn-sm text-white"
                                                    >
                                                        More Details
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="col-12">
                            <div className="result-card p-3 text-center fw-bold text-dark">
                                No matching advertisements found.
                            </div>
                        </div>
                    )}

                </div>
            </div>


            <UserFooter />

            {/* {showVisitModal && (
                <div className="modal fade show" style={{ display: "block" }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title fw-bold">
                                    Visiting Details
                                </h5>
                                <button
                                    className="btn-close"
                                    onClick={() => setShowVisitModal(false)}
                                ></button>
                            </div>

                            <div className="modal-body">
                                {selectedDetails.map((v, i) => (
                                    <div key={i} className="mb-3 border-bottom pb-2">
                                        <p className="text-dark text-capitalize">
                                            <strong>Place:</strong> {v.location}
                                        </p>
                                        <p className="text-dark text-capitalize">
                                            <strong>Days:</strong> {v.days}
                                        </p>
                                        <p className="text-dark text-capitalize">
                                            <strong>Time:</strong> {v.time}
                                        </p>
                                    </div>
                                ))}
                            </div>

                            <div className="modal-footer">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => setShowVisitModal(false)}
                                >
                                    Close
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            )} */}

            {showVisitModal && (
                <div className="vt-overlay" onClick={() => setShowVisitModal(false)}>
                    <div
                        className="vt-card"
                        onClick={(e) => e.stopPropagation()} // prevent closing when clicking card
                    >
                        <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                            <h5 className="fw-bold mb-0">Visiting Details</h5>
                            <button className="btn-close" onClick={() => setShowVisitModal(false)}></button>
                        </div>

                        {selectedDetails.map((v, i) => (
                            <div key={i} className="mb-3 border-bottom pb-2">
                                <p className="text-dark text-capitalize">
                                    <strong>Place:</strong> {v.location}
                                </p>
                                <p className="text-dark text-capitalize">
                                    <strong>Days:</strong> {v.days}
                                </p>
                                <p className="text-dark text-capitalize">
                                    <strong>Time:</strong> {v.time}
                                </p>
                            </div>
                        ))}

                        <div className="text-end mt-3">
                            <button className="btn btn-secondary" onClick={() => setShowVisitModal(false)}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}


        </>
    );
};

export default Results;
